module.exports = __webpack_public_path__ + "static/media/setting.fa7f03eb.svg";